import { omit } from 'lodash';
import { DELETE_USER_SUCCESS, FETCH_USERS_SUCCESS } from '../constants';

const byId = (state = {}, action) => {
  if (action.type === FETCH_USERS_SUCCESS) {
    return {
      ...state,
      ...action.payload.rows.entities.users,
    };
  }

  if (action.response) {
    return {
      ...state,
      ...action.response.entities.users,
    };
  }

  if (action.type === DELETE_USER_SUCCESS && state[action.payload]) {
    return omit(state, [action.payload]);
  }

  return state;
};

export default byId;
